import * as Models from "../../Models";
import * as Services from "../../Services";
import * as Shared from "../../Shared";
import * as Routes from "..";
import * as Common from "../../Common/modules";
import * as toastr from "toastr";
import * as _ from "lodash";
import * as BaseReconcileCtrl from "./BaseReconcileCtrl";
import { IPricingApiClient } from "../../Services/PricingApiClient";

export class AmendRateEscalatorCtrl extends BaseReconcileCtrl.BaseReconcileCtrl {
    
    public amendedContractText = 'No';

    public static $inject = ['UserService', '$state', 'CostCalculationApiClient', 'CustomerApiClient',
        'MarketAssumedValuesApiClient', 'ContractAmendmentApiClient', 'igs.messageBox', '$timeout', 'PricingApiClient'];

    constructor(
        userService: Services.UserService.IUserService,
        $state: angular.ui.IStateService,
        costCalculationApiClient: Services.CostCalculationApiClient.ICostCalculationApiClient,
        customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
        marketAssumedValuesApiClient: Services.MarketAssumedValuesApiClient.IMarketAssumedValuesApiClient,
        contractAmendmentApiClient: Services.ContractAmendmentApiClient.IContractAmendmentApiClient,
        messageBox: any,
        $timeout: angular.ITimeoutService,
        pricingApiClient: IPricingApiClient) {
        super(userService,
            $state,
            costCalculationApiClient,
            customerApiClient,
            marketAssumedValuesApiClient,
            contractAmendmentApiClient,
			messageBox,
            $timeout,
            pricingApiClient,
            );
    }

    protected setupPage(): void {
        super.setupPage();
    }

	protected validate(): boolean {
		return true;
	}

    protected onEpcReconciled(): void {
        this.setupPage();
    }

    public toggleHasAmendedContractButton = (): void => {
        if (this.costCalculationModel.hasAmendedContract) {
            this.costCalculationModel.hasAmendedContract = false;
            this.reloadPreviousEpcCalculationResponse();
            this.calculateEpcNogLog(true);
        } else {
            this.costCalculationModel.hasAmendedContract = true;
        }
	}

    private reloadPreviousEpcCalculationResponse = (): void => {
        this.costCalculationModel.market = this.getCorrespondingMarket(this.reconcileEpc.market);
        this.costCalculationModel.rate = this.reconcileEpc.rate;
        this.costCalculationModel.annualProduction = this.reconcileEpc.annualProduction;
        this.costCalculationModel.systemSize = this.reconcileEpc.systemSize;
        this.costCalculationModel.productCode = this.reconcileEpc.productCode;
        this.costCalculationModel.monthlyPayment = this.reconcileEpc.monthlyPayment;

        this.selectedRegionPricing = _.find(this.regionAssociatedToCustomer.regionPricings,
            rp => rp.regionPricingId === this.reconcileEpc.regionPricingId);

        this.costCalculationModel.regionPricingId = this.selectedRegionPricing.regionPricingId;
    }

    private getCorrespondingMarket = (market: Models.CostCalculation.Market.IMarket): Models.CostCalculation.Market.IMarket => {
        var correspondingMarket: Models.CostCalculation.Market.IMarket;
        this.possibleMarkets.forEach(x => {
            if (x.code === market.code) {
                correspondingMarket = x;
            }
        });
        return correspondingMarket;
    }
}